<template>
  <a href="" class="logout" @click.prevent="hasToken ? doLogout() : doLogin()">
    <span :class="`icon-log-${hasToken ? 'out-circle' : 'in-circle'}`">
      <span class="path1"></span>
      <span class="path2"></span>
      <span class="path3"></span>
    </span>
    {{ hasToken ? langJson[lang].logout : langJson[lang].login }}
  </a>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';
  import { useRoute } from 'vue-router';
  import { saveRedirectLocation, clearRedirectLocation } from '@/utils/redirectLocation';

  const mainStore = useMainStore();
  const langJson = computed(() => mainStore.langJson);
  const lang = computed(() => mainStore.lang);
  const hasToken = computed(() => mainStore.hasToken);
  const route = useRoute();
  const { $msal } = useNuxtApp() as any;

  function doLogin() {
    // Preserve current location for post-login redirect
    saveRedirectLocation(route.path, route.hash || '');
    if ($msal && typeof $msal.loginRedirect === 'function') {
      $msal.loginRedirect();
    } else if (typeof window !== 'undefined' && (window as any).msal) {
      (window as any).msal.loginRedirect();
    }
  }

  function doLogout() {
    // Clear token cookie and update store state
    useCookie('token').value = null;
    mainStore.hasToken = false;
    // Clear any pending redirect since we're logging out
    clearRedirectLocation();
    if ($msal && typeof $msal.logout === 'function') {
      $msal.logout();
    } else if (typeof window !== 'undefined' && (window as any).msal) {
      (window as any).msal.logout();
    }
  }
</script>
